var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import Select from 'react-select';
import { Card, CardBody, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import Seatmap from '../../../components/Seatmap';
import { T } from '../../../helpers/i18n';
import cxs from 'cxs/component';
import { DirectionNumeration, MapSite, Numeration, Seat } from 'modules/SeatingAreas/Model';
import { Button } from 'elements';
import theme from '../../../Theme';
var Zoneconfig = /** @class */ (function (_super) {
    __extends(Zoneconfig, _super);
    function Zoneconfig(props) {
        var _this = _super.call(this, props) || this;
        _this.optionsSeat = [{ label: 'blank', value: 'blank' }, { label: 'seat', value: 'seat' }, { label: T('handicapped'), value: 'handicapped' },];
        _this.optionsNumeration = [{ label: T(Numeration.Sequent), value: Numeration.Sequent }, { label: T(Numeration.Pair), value: Numeration.Pair }, { label: T(Numeration.Odd), value: Numeration.Odd }];
        _this.optionsDirectionNumeration = [{ label: T(DirectionNumeration.Right), value: DirectionNumeration.Right }, { label: T(DirectionNumeration.Left), value: DirectionNumeration.Left }];
        _this.optionsType = [{ label: 'por categorias de butacas(primera, segunda, vip, vision reducida)', value: 'bySeat' }, { label: 'por categoria de pasajero (adulto, niño, ....)' }];
        _this.optionRows = [];
        _this.state = {
            typeSeat: '',
            typeNumeration: '',
            quantity: 0,
            // rows: [],
            rowSelected: undefined,
            seatZoneSelected: undefined,
            offsetLeft: 0,
            offsetRight: 0,
            offsetTop: 0,
            offsetBottom: 0,
            /*rows: [
              [
                {id: 1, numero: 'a', offsetLeft: 0},
                {id: 2, numero: 'b'},
                {id: 3, numero: '3', isReserved: true, offsetLeft: 10},
                {id: 4, numero: '4'},
                {id: 5, numero: 5},
                {id: 6, numero: 6},
                {id: 7, numero: 7, isReserved: true},
                {id: 8, numero: 8, isReserved: true},
                {id: 9, numero: '9', isReserved: true},
                {id: 10, numero: '10'},
                {id: 11, numero: 11},
                {id: 12, numero: 12}
              ],
              ]*/
            /*rows: [
              [
                {
                  'id': 1,
                  'numero': 'a',
                  'offset': 0
                },
                {
                  'id': 2,
                  'numero': 'b'
                },
                null,
                {
                  'id': 3,
                  'numero': '3',
                  'isReserved': true,
                  'offset': 0
                },
                {
                  'id': 4,
                  'numero': '4'
                },
                {
                  'id': 5,
                  'numero': 5
                },
                {
                  'id': 6,
                  'numero': 6
                },
                {
                  'id': 7,
                  'numero': 7,
                  'isReserved': true
                },
                {
                  'id': 8,
                  'numero': 8,
                  'isReserved': true
                },
                {
                  'id': 9,
                  'numero': '9',
                  'isReserved': true
                },
                {
                  'id': 10,
                  'numero': '10'
                },
                {
                  'id': 11,
                  'numero': 11
                },
                {
                  'id': 12,
                  'numero': 12
                },
                {
                  'onlyHandicapped': false,
                  'status': 'idle',
                  'id': 14,
                  'numero': 14,
                  'seatCategories': null
                },
                {
                  'onlyHandicapped': false,
                  'status': 'idle',
                  'id': 15,
                  'numero': 15,
                  'seatCategories': null
                }
              ]
            ]*/
        };
        _this.handleOnSelect = function (e) {
            var seatsSelected = [];
            e.selected.forEach(function (value) {
                var seatS = JSON.parse(value.attributes['data-seat'].value);
                var seat = null;
                if (seatS) {
                    seat = new Seat(seat);
                }
                seatsSelected.push(seat);
            });
            console.log('seatsSelected: ', seatsSelected);
            /*e.added.forEach(el => {
              el.classList.add('seat--selected');
            });*/
            /*e.removed.forEach(el => {
              el.classList.remove('seat--selected');
            });*/
        };
        _this.handleSeatEdit = function () {
        };
        _this.handleAddSeatCallback = function (_a, addCb, params, removeCb) {
            var row = _a.row, numero = _a.numero, id = _a.id;
            // console.log('row: ', row)
            // console.log('numero: ', numero)
            // console.log('id: ', id)
            var tempRows = _this.state.seatZoneSelected.rows;
            // console.log('handleAddSeatCallback - tempRows: ', tempRows)
            var tempRow = tempRows[row - 1][numero - 1];
            // console.log('handleAddSeatCallback - tempRow: ', tempRow)
            _this.setState({ seatSelected: tempRow });
            // console.log('params: ', params)
            if (removeCb) {
                removeCb(params.row, params.numero, null, row, numero, id);
            }
            else {
                addCb(row, numero, id);
            }
        };
        _this.handleRow = function (value) {
            _this.setState({ rowSelected: value.value });
        };
        _this.handleTypeCategorySeat = function (value, action) {
            console.log('añadiendo row y numberSeat');
            var seatZoneSelected = _this.state.seatZoneSelected;
            seatZoneSelected.rows.map((function (row, indexRow) {
                return row.map(function (seat, indexSeat) {
                    if (!seat)
                        return seat;
                    if (!seat.row) {
                        seat.row = indexRow;
                    }
                    if (!seat.numberSeat) {
                        seat.numberSeat = indexSeat;
                    }
                    return seat;
                });
            }));
        };
        _this.handleTypeSeat = function (value, action) {
            _this.setState({ typeSeat: value.value });
        };
        _this.handleSeatZone = function (value, action) {
            console.log('handleSeatZone - value: ', value);
            _this.setState({ seatZoneSelected: value.value });
        };
        _this.handleNumeration = function (value, action) {
            console.log('value: ', value);
            console.log('action: ', action);
        };
        _this.handleDirectionNumeration = function (value, action) {
            console.log('value: ', value);
            console.log('action: ', action);
        };
        _this.handleQuantity = function (event) {
            _this.setState({ quantity: event.target.value });
        };
        _this.handleAddRow = function () {
            var seatZoneSelected = _this.state.seatZoneSelected;
            var nuevo = [];
            seatZoneSelected.rows.push(nuevo);
            _this.setState({ seatZoneSelected: seatZoneSelected });
        };
        _this.handleOffsetRight = function (event) {
            _this.setState({ offsetRight: event.target.value });
        };
        _this.handleOffsetLeft = function (event) {
            _this.setState({ offsetLeft: event.target.value });
        };
        _this.handleOffsetTop = function (event) {
            _this.setState({ offsetTop: event.target.value });
        };
        _this.handleOffsetBottom = function (event) {
            _this.setState({ offsetBottom: event.target.value });
        };
        _this.handleAdd = function () {
            var _a = _this.state, typeSeat = _a.typeSeat, typeNumeration = _a.typeNumeration, quantity = _a.quantity, rowSelected = _a.rowSelected, offsetRight = _a.offsetRight, offsetLeft = _a.offsetLeft, offsetTop = _a.offsetTop, offsetBottom = _a.offsetBottom, seatZoneSelected = _a.seatZoneSelected;
            console.log('handleAdd - seatZoneSelected: ', seatZoneSelected);
            var rows = seatZoneSelected.rows;
            for (var i = 0; i < quantity; i++) {
                if (typeSeat === 'blank') {
                    rows[rowSelected].push(null);
                }
                else {
                    console.log('rowSelected: ', rowSelected);
                    var onlyHandicapped = (typeSeat === 'handicapped');
                    var id = rows[rowSelected].length + 1;
                    // numeramos
                    var seat = new Seat({
                        id: id,
                        blank: false,
                        row: rowSelected,
                        numberSeat: id,
                        numero: id,
                        offsetRight: Number(offsetRight),
                        offsetLeft: Number(offsetLeft),
                        offsetTop: Number(offsetTop),
                        offsetBottom: Number(offsetBottom),
                        onlyHandicapped: onlyHandicapped,
                    });
                    rows[rowSelected].push(seat);
                }
                console.log('handleAdd - rows: ', rows);
                seatZoneSelected.rows = rows;
                _this.setState({ seatZoneSelected: seatZoneSelected });
                if (_this.props.onChange) {
                    var sites = _this.optionsSeatZone.map(function (zone) { return zone.value; });
                    var mapSite = new MapSite();
                    mapSite.seatZones = sites;
                    _this.props.onChange(mapSite);
                }
            }
        };
        _this.handleKeyUpQuantity = function (event) {
            if (_this.state.rowSelected !== undefined && event.keyCode === 13) {
                _this.handleAdd();
            }
        };
        if (props.mapSite) {
            _this.optionsSeatZone = _this.props.mapSite.map(function (seatZone) {
                return {
                    label: seatZone.name,
                    value: seatZone
                };
            });
        }
        return _this;
    }
    Zoneconfig.prototype.render = function () {
        var _a = this.state, rowSelected = _a.rowSelected, seatZoneSelected = _a.seatZoneSelected;
        var rows = [];
        if (seatZoneSelected) {
            // console.log('rows: ', seatZoneSelected.rows)
            rows = seatZoneSelected.rows;
            this.optionRows = rows.map(function (row, index) { return ({ label: String(index + 1), value: index }); });
        }
        return (React.createElement(Container, { style: { overflow: 'visible' } },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, 'Zona'),
                        React.createElement(Select, { options: this.optionsSeatZone, onChange: this.handleSeatZone })),
                    React.createElement("div", { style: {
                            width: '100%',
                            borderBottom: "".concat(theme.size.hairline, " solid ").concat(theme.color.hairline)
                        } }))),
            React.createElement("div", { style: {} }),
            React.createElement(Row, { md: 3, sm: 6 },
                React.createElement(Col, null,
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, T('offsetLeft')),
                        React.createElement(Input, { style: { width: '100%' }, type: 'number', onChange: this.handleOffsetRight, onKeyUp: this.handleKeyUpQuantity }))),
                React.createElement(Col, null,
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, T('offsetRight')),
                        React.createElement(Input, { style: { width: '100%' }, type: 'number', onChange: this.handleOffsetRight, onKeyUp: this.handleKeyUpQuantity }))),
                React.createElement(Col, null,
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, T('offsetTop')),
                        React.createElement(Input, { style: { width: '100%' }, type: 'number', onChange: this.handleOffsetTop, onKeyUp: this.handleKeyUpQuantity }))),
                React.createElement(Col, null,
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, T('offsetBottom')),
                        React.createElement(Input, { style: { width: '100%' }, type: 'number', onChange: this.handleOffsetBottom, onKeyUp: this.handleKeyUpQuantity })))),
            React.createElement(Row, null,
                React.createElement(Col, { md: 3, sm: 4, xs: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-around' } },
                            React.createElement(Wrapper, null, T('row')),
                            React.createElement(Button, { primary: true, onClick: this.handleAddRow, disabled: !seatZoneSelected }, T('addRow'))),
                        React.createElement(Select, { options: this.optionRows, onChange: this.handleRow }))),
                React.createElement(Col, { md: 2, sm: 4, xs: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, 'tipo de asiento'),
                        React.createElement(Select, { options: this.optionsSeat, onChange: this.handleTypeSeat, defaultValue: this.optionsSeat[1] }))),
                React.createElement(Col, { md: 3, sm: 4, xs: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, 'tipo de numeración'),
                        React.createElement(Select, { options: this.optionsNumeration, onChange: this.handleNumeration, defaultValue: this.optionsNumeration[0] }))),
                React.createElement(Col, { md: 2, sm: 4, xs: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, 'orden numeración'),
                        React.createElement(Select, { options: this.optionsDirectionNumeration, onChange: this.handleDirectionNumeration, defaultValue: this.optionsDirectionNumeration[0] }))),
                React.createElement(Col, { md: 2, sm: 4, xs: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, T('quantity')),
                        React.createElement(Input, { style: { width: '100%' }, type: 'number', onChange: this.handleQuantity, onKeyUp: this.handleKeyUpQuantity })))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, 'tipo de butacas'),
                        React.createElement(Select, { options: this.optionsType, onChange: this.handleTypeCategorySeat })))),
            React.createElement(Row, null,
                React.createElement(Button, { primary: true, disabled: rowSelected === undefined, onClick: this.handleAdd }, T('addSeats'))),
            React.createElement(Card, { className: "bg-gray-100", style: { minHeight: '300px' } },
                React.createElement(CardBody, null,
                    React.createElement(Container, null,
                        React.createElement(Row, null,
                            React.createElement(Col, null,
                                React.createElement(Seatmap, { maxReservableSeats: 100, visible: true, 
                                    // selectedByDefault
                                    rows: rows, 
                                    // @ts-ignore
                                    addSeatCallback: this.handleAddSeatCallback, continuous: true }),
                                React.createElement("div", { className: 'empty elements' })))))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(FormGroup, null,
                        React.createElement(Wrapper, null, T('numeration')),
                        React.createElement(Input, { style: { width: '100%' }, type: 'number', onChange: this.handleSeatEdit, value: this.state.seatSelected ? this.state.seatSelected.numero : '' }))))));
    };
    return Zoneconfig;
}(Component));
export default Zoneconfig;
var Wrapper = cxs(Label)({
    height: '35px',
    marginBottom: 0,
    paddingTop: '0.7rem',
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/SeatingAreas/container/Zoneconfig.tsx
// module id = 1400
// module chunks = 0